<!-- Auth card -->
<article class="auth-card">
  <div class="auth-content">
    <!-- Header section -->
    <header class="card-header">
      <h2>CAMBIAR CONTRASEÑA</h2>
      <p class="helper-text info-message">
        Se enviará un <strong>código de verificación</strong> por correo o SMS para cambiar tu contraseña
      </p>
    </header>

    <!-- Form section -->
    <form action="post" [formGroup]="sendCodeForm" (ngSubmit)="onSendCode()" class="auth-form" novalidate>
      <div class="alert-span-exeption" aria-live="polite">
        <span *ngIf="exceptionMessage != ''" [@inOutAnimation] class="error-message">{{ exceptionMessage }}</span>
      </div>

      <div class="form-field">
        <label for="givenEmail">Correo electrónico</label>
        <input
          id="givenEmail"
          type="text"
          name="email"
          placeholder="Tu correo electrónico"
          class="textInput"
          formControlName="givenEmail"
        >
      </div>

      <div class="alert-span" *ngIf="sendCodeFormValidation['givenEmail'].touched && sendCodeFormValidation['givenEmail'].invalid">
        <label class="error-message" *ngIf="sendCodeFormValidation['givenEmail'].errors && sendCodeFormValidation['givenEmail'].errors['required']" [@inOutAnimation]>
          Este campo es requerido
        </label>
        <label class="error-message" *ngIf="sendCodeFormValidation['givenEmail'].errors && sendCodeFormValidation['givenEmail'].errors['pattern'] && sendCodeFormValidation['givenEmail'].errors['email']" [@inOutAnimation]>
          Formato de correo incorrecto
        </label>
      </div>

      <!-- Action section -->
      <div class="form-buttons d-flex-column action-section">
        <button type="submit" [disabled]="sendCodeForm.invalid" class="submit-btn">Enviar código</button>
      </div>
    </form>
  </div>
</article>
